import { render, staticRenderFns } from "./Streak.vue?vue&type=template&id=84b994ce&scoped=true"
import script from "./Streak.vue?vue&type=script&lang=js"
export * from "./Streak.vue?vue&type=script&lang=js"
import style0 from "./Streak.vue?vue&type=style&index=0&id=84b994ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b994ce",
  null
  
)

export default component.exports